import { render, staticRenderFns } from "./NtapsShipmentArchive.vue?vue&type=template&id=29e3f3c2&"
import script from "./NtapsShipmentArchive.vue?vue&type=script&lang=js&"
export * from "./NtapsShipmentArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports